import {
  Avatar,
  Badge,
  Button,
  Input,
  Tag,
} from "antd";

import {
  BellOutlined,
  MenuOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function Topbar({
  openSidebar,
}) {

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  useEffect(() => {
    const updateUser = () => {
      setUserInfo(
        JSON.parse(localStorage.getItem("userInfo"))
      );
    };

    window.addEventListener("userUpdated", updateUser);

    return () => {
      window.removeEventListener("userUpdated", updateUser);
    };
  }, []);
  // const userInfo = JSON.parse(localStorage.getItem('userInfo'))

  const [show, setshow] = useState(false)

  const onClickOutsideListener = () => {
    setshow(false)
    document.removeEventListener("click", onClickOutsideListener)
  }

  const handlelogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    // localStorage.clear()
    alert('Log-Out')
    window.location.reload('/')
  }


  return (
    <div
      style={{
        height: 70,
        background: "#fff",
        padding: "0 16px",
        display: "flex",
        justifyContent:
          "space-between",
        alignItems: "center",
        borderBottom:
          "1px solid #eee",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
        }}
      >
        <Button
          className="mobile-menu"
          icon={<MenuOutlined />}
          onClick={openSidebar}
        />

        <h2
          style={{
            margin: 0,
            fontSize: 22,
          }}
        >
          Dashboard
        </h2>
      </div>

      <div
        style={{
          display: "flex",
          gap: 15,
          alignItems: "center",
        }}
      >
        {/* <Input
          placeholder="Search..."
          className="desktop-search"
          style={{
            width: 250,
          }}
        /> */}

        {/* Credits */}
        {/* <Tag
          color="orange-inverse"
          icon={<WalletOutlined />}
          style={{
            padding: "6px 12px",
            borderRadius: 20,
            fontSize: 14,
            fontWeight:'bold'
          }}
        >
          {userInfo?.wallet} Credits
        </Tag> */}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "#6b3fde",
            color: "white",
            padding: "8px 10px",
            borderRadius: "12px",
            fontWeight: 600,
            fontSize: "14px",
          }}
        >
          <div

          />
          {<WalletOutlined />} {userInfo?.wallet} Credits
        </div>

        <Badge count={2}>
          <BellOutlined
            style={{
              fontSize: 20,
            }}
          />
        </Badge>

        <Avatar onMouseLeave={() => {
          document.addEventListener("click", onClickOutsideListener)
        }} onClick={() => setshow(!show)} className="uppercase bg-blue-600 cursor-pointer">{userInfo?.name[0]}</Avatar>
      </div>

      {show && <div class="myprofildrop bg-white text-base z-50 list-none divide-y divide-gray-100 rounded shadow-2xl mt-32 ">
        <div class="px-4 py-3">
          <span class="block text-sm font-medium text-gray-900 truncate">ID: {userInfo?.id}</span>
          <span class="block text-sm">{userInfo?.name}</span>
          <span class="block text-sm font-medium text-gray-900 truncate">{userInfo?.email}</span>
        </div>
        <ul className="py-1" aria-labelledby="dropdown">



          <li>
            <a onClick={handlelogout} class=" myaaaa text-sm hover:bg-gray-100 text-gray-700 block px-4 py-2">Sign out</a>
          </li>
        </ul>
      </div>}
    </div>
  );
}